import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function dynamicTableModel() {
  const fetchQueryDisplayModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/QueryDisplay_List",
    method: "POST",
    payload: {
      DisplayId: "",
      Display_Key: "",
    },
  });

  const fetchQueryDataModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/QueryData_List",
    method: "POST",
    payload: {
      QueryDataId: "",
      Page: 1,
      Limit: "",
      Filters: [],
      Ordering: [],
      DisplayId: "",
      Display_Key: "", //optional
      QueryData_Key: "", //optional
      IsVerified: false
    },
  });

  const editDisplayModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/EditDisplay",
    method: "POST",
    payload: {
      DispalyConfigs: [],
      DisplayId: null,
      Display_Key: null, //optional
    },
  });

  const editDisplayTableColumnModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/EditDisplayTableColumn",
    method: "POST",
    payload: {
      Key: null,
      From_Seq: null,
      To_Seq: null,
      action_list: [],
      DisplayId: null,
      Display_Key: "", //optional
    },
  });

  const fetchQueryDataDetailModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/QueryData_Detail",
    method: "POST",
    payload: {
      QueryDataId: null,
      QueryData_Key: null,
      Payloads: [{ Key: null, Value: null }],
    },
  });

  const editDataModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/Edit",
    method: "POST",
    payload: {},
  });

  const fetchQueryDisplayReportModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/Display_Report_Form",
    method: "POST",
    payload: {
      Display_Key: "bcrm_report_privilege",
    },
  });

  const GetBrandAppDetailModel = reactive({
    api: apiEndpoint.bcrm_platform + "/DynamicTable/GetBrandAppDetail",
    method: "POST",
    payload: {},
  });

  return {
    fetchQueryDisplayModel,
    fetchQueryDataModel,
    editDisplayModel,
    editDisplayTableColumnModel,
    fetchQueryDataDetailModel,
    editDataModel,
    fetchQueryDisplayReportModel,
    GetBrandAppDetailModel,
  };
}
